import script from "./ShopDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopDetails.vue?vue&type=script&setup=true&lang=js"

import "./ShopDetails.vue?vue&type=style&index=0&id=caae6628&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caae6628"]])

export default __exports__